import React, { useContext, useEffect, useState } from "react";
// React Bootstrap
import { Accordion, Card, Button, Container } from "react-bootstrap";
// // Contexto
import { ModalContext } from "../../../context/modalContext";
import { AlertBoxContext } from "../../../context/alertBoxContext";
// jquery
import $ from "jquery";
// Custom spinner
import CustomSpinner from "../../generic/CustomSpinner";
// Form
import MisionExtraForm from "../formularios/MisionExtraForm";
import MisionExtraModal from "./misionExtraModal";
// Componentes

const MisionExtra = ({ sisterId, state, accessLevel, userId, ...props }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  // Situaciones particulares
  const [misionesExtra, setMisionesExtra] = useState([]);
  // Custom spinner
  const [loading, setLoading] = useState(false);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);

  //********************************************** REQUESTS ****************************************************
  //------------------------------------------------ GET -------------------------------------------------------
  // Obtiene todas las misiones extra
  const getMisionExtra = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/usuarios/${userId}/misionextra`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  //------------------------------------------------ POST -------------------------------------------------------
  // Añade una misión extra
  const postMisionExtra = (data) => {
    
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/usuarios/${userId}/misionextra`,
      method: "POST",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  //------------------------------------------------ PUT -------------------------------------------------------
  // Actualiza misión extra
  const putMisionExtra = (data) => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/usuarios/${userId}/misionextra/${data.id}`,
      method: "PUT",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  //------------------------------------------------ DELETE -------------------------------------------------------
  // Elimiina misión extra
  const delMisionExtra = (data) => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/usuarios/${userId}/misionextra/${data.id}`,
      method: "DELETE",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  //********************************************** HANDLERS ****************************************************/
  // Manejador para las misiones extra
  const handleGetMisionExtra = () => {
    setLoading(true);
    getMisionExtra()
      .then((response) => {
        setLoading(false);
        setMisionesExtra(response.items);
      })
      .catch(() => {
        setLoading(false);
        addAlert("Error", "Error al solicitar las misiones de la hermana", "danger");
      });
  };

  const handlePostMisionExtra = (data) => {
    modalSetShow(false);
    setLoading(true);
    postMisionExtra(data)
      .then((response) => {
        setLoading(false);
        setMisionesExtra([response, ...misionesExtra]);
        addAlert("Éxito", "Se ha añadido la misión correctamente", "success");
      })
      .catch(() => {
        setLoading(false);
        addAlert("Error", "Error al añadir la misión de la hermana", "danger");
      });
  };

  const handlePutMisionExtra = (data) => {
   
    modalSetShow(false);
    setLoading(true);
    putMisionExtra(data)
      .then((response) => {
        handleGetMisionExtra();
        setLoading(false);
        addAlert("Éxito", "Se ha actualizado la misión correctamente", "success");
      })
      .catch(() => {
        setLoading(false);
        addAlert("Error", "Error al actualizar la misión de la hermana", "danger");
      });
  };

  const handleDeleteMisionExtra = (data) => {
    modalSetShow(false);
    setLoading(true);
    delMisionExtra(data)
      .then((response) => {
        handleGetMisionExtra();
        setLoading(false);
        addAlert("Éxito", "Se ha eliminado la misión correctamente", "success");
      })
      .catch(() => {
        setLoading(false);
        addAlert("Error", "Error al eliminar la misión de la hermana", "danger");
      });
  };

  // UEF

  useEffect(() => {
    handleGetMisionExtra();
  }, []);

  return (
    <div style={{ position: "relative" }}>
      <CustomSpinner animation={"border"} loading={loading} />
      <Accordion defaultActiveKey="1">
        <Card>
          <Card.Header>
            <Accordion.Toggle eventKey="0" as={Button} variant="link">
              Otra misión
            </Accordion.Toggle>
            {accessLevel >= 9 && (
              <Button
                variant="outline-primary"
                size="sm"
                className="float-right mr-4"
                onClick={() => {
                  modalSetShow(true, "60%");
                  modalSetTitle("Añadir misión");
                  modalSetContent(<MisionExtraForm submissionHandler={handlePostMisionExtra} userId={userId}/>);
                }}
              >
                Añadir
              </Button>
            )}
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <p>
                <small>Ordenado de más reciente a más antiguo</small>
              </p>
              {misionesExtra.length ? (
                misionesExtra.map((misionExtra) => {
                  return <MisionExtraModal accessLevel={accessLevel} key={misionExtra.id} misionExtra={misionExtra} handleDeleteMisionExtra={handleDeleteMisionExtra} handlePutMisionExtra={handlePutMisionExtra}/>;
                })
              ) : (
                <p>No hay otra misión que mostrar actualmente.</p>
              )}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default MisionExtra;
